export enum Locales {
    FR = 'fr_FR',
    FR_CSE = 'fr_FR_CSE',
    NL = 'nl_NL',
    UK = 'en_US'
}